import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const homeFor = (role) => (role === "admin" ? "/admin" : role === "supplier" ? "/supplier" : "/dashboard");

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        if (data.needs_registration) {
          toast.info("Complétez votre inscription pour rejoindre la plateforme");
          navigate("/register", { replace: true, state: { google: data } });
          return;
        }
        localStorage.setItem("token", data.token);
        setUser(data.user);
        toast.success("Connexion Google réussie");
        navigate(homeFor(data.user.role), { replace: true });
      })
      .catch((e) => {
        toast.error(formatApiError(e.response?.data?.detail));
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-callback">
      <div className="h-10 w-10 rounded-full border-2 border-indigo-600 border-t-transparent animate-spin" />
    </div>
  );
}
